export const SPACE_OCCUPANCY = 'SPACE_OCCUPANCY'
export const FILTER_NAME = 'spaceOccupancy'
export const PAGENAME = 'spaceOccupancy'
export const ns = 'SpaceOccupancy'

export const STORE_KEY = 'spaceOccupancy'
export const DEFAULT_PAGE_SIZE = 10
export const SELECTED_ROWS_COUNT = `${ns}.SELECTED_ROWS_COUNT`
